/* @flow */

export const SHOW_INTEREST_GUIDANCE = 'SHOW_INTEREST_GUIDANCE';
export const HIDE_INTEREST_GUIDANCE = 'HIDE_INTEREST_GUIDANCE';

export const SHOW_INTEREST_SELECTION = 'SHOW_INTEREST_SELECTION';
export const HIDE_INTEREST_SELECTION = 'HIDE_INTEREST_SELECTION';
